import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    materiom: {
      eggshell: string;
      seaweed: string;
      charcoal: string;
    };
  }
  interface PaletteOptions {
    materiom?: {
      eggshell?: string;
      seaweed?: string;
      charcoal?: string;
    };
  }
}

/**
 * Custom theme configuration for the application
 * Uses Montserrat as the primary font and defines a modern, sleek appearance
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: "#072531", // materiom-tapioca
      light: "#7AA8A3",
      dark: "#4A7A75",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#666666", // materiom-charcoal
      light: "#808080",
      dark: "#4D4D4D",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F5F5F5", // materiom-eggshell
      paper: "#FFFFFF",
    },
    materiom: {
      eggshell: "#F5F5F5",
      seaweed: "#4d7e78",
      charcoal: "#666666",
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
    h3: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h6: {
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontSize: "0.9rem",
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#072531",
          color: "#ffffff",
          fontSize: "0.75rem",
          padding: "8px 12px",
        },
        arrow: {
          color: "#072531",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: "rgba(0, 0, 0, 0.1) transparent",
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            width: "2px",
            height: "2px",
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: "1px",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            minHeight: "24px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.15)",
            },
          },
          "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
});
